import React, { createContext, useEffect } from "react";

// Create the context
export const ThemeContext = createContext();

// Create a provider component
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.style.setProperty("--text-color", "#0A0101");
    document.documentElement.style.setProperty("--background-color", "#FFFBFB");
    document.documentElement.style.setProperty("--primary-color", "#640507");
    document.documentElement.style.setProperty("--cards-background", "#FFFBFB");
  }, []);

  return (
    <ThemeContext.Provider value={{}}>
      {children}
    </ThemeContext.Provider>
  );
};
